/* eslint-disable @typescript-eslint/no-explicit-any */
export const throttle = (callback: any) => {
    let rid: any = null;
    let saveArgs: any[];

    const makeCallback = (context: any) => () => {
        rid = null;
        callback.apply(context, saveArgs);
    };

    const throttled = function (...args: any[]) {
        saveArgs = args;
        if (rid === null) {
            // @ts-expect-error this
            rid = requestAnimationFrame(makeCallback(this));
        }
    };

    return throttled;
};
